import jwtDecode from 'jwt-decode';
import {
  persistedTypes,
  mutationTypes,
  actionTypes } from '@/store/types';
import cookies from 'js-cookie';

const state = {
  token: null,
};

const getters = {
};

const actions = {
  [actionTypes.session.recall]({ commit }) {
    const rememberedToken = cookies.get(persistedTypes.token.value);
    if (rememberedToken) {
      commit(mutationTypes.session.setToken, rememberedToken);
    }
  },

  [actionTypes.session.setToken]({ commit }, payload) {
    const tokenData = jwtDecode(payload);
    if (tokenData.iss !== 'irco.com') return;

    cookies.set(persistedTypes.token.value, payload);
    commit(mutationTypes.session.setToken, payload);
  },
};

const mutations = {
  [mutationTypes.session.setToken](state, payload) {
    state.token = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/session.js